import React from 'react';

const RegistryPrint = React.forwardRef(({ registry }, ref) => {
  return (
    <div ref={ref} className="p-6">
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold">Registry Detailed Report</h1>
        <p className="text-lg">Registry Closed By: {registry?.createdBy?.name ?? "Unknown User"}</p>        <p>Date: {new Date(registry.date).toLocaleDateString()}</p>
      </div>

      <div className="mb-6 grid grid-cols-2 gap-4">
        <div>
          <p><strong>Status:</strong> {registry.isOpen ? 'OPEN' : 'CLOSED'}</p>
          <p><strong>Created By:</strong> {registry.createdBy?.name}</p>
          <p><strong>Total Invoices:</strong> {registry.totalInvoices}</p>
        </div>
        <div>
          <p><strong>Opening Balance:</strong> {registry.openingBalance?.toFixed(2)}</p>
          <p><strong>Closing Balance:</strong> {registry.closingBalance?.toFixed(2)}</p>
          <p><strong>Total Sales:</strong> {registry.totalSales?.toFixed(2)}</p>
        </div>
      </div>

      <h2 className="text-xl font-bold mb-4">Invoices</h2>
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 p-2">Invoice #</th>
            <th className="border border-gray-300 p-2">Date</th>
            <th className="border border-gray-300 p-2">Customer</th>
            <th className="border border-gray-300 p-2">Subtotal</th>
            <th className="border border-gray-300 p-2">Tax</th>
            <th className="border border-gray-300 p-2">Total</th>
            <th className="border border-gray-300 p-2">Status</th>
          </tr>
        </thead>
        <tbody>
          {registry.invoiceIds?.map((invoice, index) => (
            <tr key={invoice._id} className={index % 2 === 0 ? 'bg-gray-50' : ''}>
              <td className="border border-gray-300 p-2">{invoice.number}</td>
              <td className="border border-gray-300 p-2">
                {new Date(invoice.date).toLocaleDateString()}
              </td>
              <td className="border border-gray-300 p-2">
                {invoice.customer ? 'Customer' : 'Walk-in'}
              </td>
              <td className="border border-gray-300 p-2 text-right">
                {invoice.subtotal?.toFixed(2)}
              </td>
              <td className="border border-gray-300 p-2 text-right">
                {invoice.taxamount?.toFixed(2)}
              </td>
              <td className="border border-gray-300 p-2 text-right">
                {invoice.total?.toFixed(2)}
              </td>
              <td className="border border-gray-300 p-2">
                {invoice.payment_status === 1 ? 'Paid' : 'Pending'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {registry.notes && (
        <div className="mt-6">
          <h3 className="font-bold">Notes:</h3>
          <p>{registry.notes}</p>
        </div>
      )}

      <div className="mt-8 text-right">
        <p>Printed on: {new Date().toLocaleString()}</p>
      </div>
    </div>
  );
});

export default RegistryPrint;